<template>
        <!-- v-click-outside="doClickOutside" -->
    <tr
      @keydown.esc="cancel"
      @click="startEditMode()"
      :class="{'problematicArticle': problematicArticle}"
    >
        <td>{{name}}</td>
        <td>{{category_name}}</td>
        <td>{{purchase_measurement_unit_name}}</td>
        <td>{{price | price(2)}}</td>
        <td>
            <v-text-field
                style="margin: 0!important; padding: 0!important;"
                v-model="new_price"
                ref="new_price"
                @keydown="preventLetters"
                @keydown.enter="parsePriceInput(); save();"
                @keydown.tab.prevent="parsePriceInput(); save();"
                @blur="new_price && parsePriceInput(); stopEditMOde(); handleBlur();"
                @focus="$emit('setCurrent', article.sort);startEditMode(); $event.target.select()"
                :disabled="saving"
            ></v-text-field>
        </td>

        <td class='text-right' v-show="!saving && editMode">
            <ButtonActionSave @click.stop="save" />
            <ButtonActionCloseEditing @click.stop="cancel" />
        </td>
        <td v-show="saving">
            <v-progress-circular
              :size="20"
              indeterminate
              color="teal"
            ></v-progress-circular>
        </td>
    </tr>
</template>

<script>
import ButtonActionSave from '@/components/ButtonActionSave'
import ButtonActionCloseEditing from '@/components/ButtonActionCloseEditing'
import { parsePrice } from '@/utils/price'
import { mapActions } from 'vuex'

export default {
  components: {
    ButtonActionSave,
    ButtonActionCloseEditing,
  },
  props: {
    article: {
      default: () => {},
      type: Object
    },
    isNewArticle: {
      required: false,
      type: Boolean
    }, newKez: {
      type: Number,
    }
  },
  data () {
    return {
      name: null,
      category_name: null,
      purchase_measurement_unit_name: 0,
      price: null,
      new_price: null,
      editMode: false,
      problematicArticle: false,
      saving: false
    }
  },
  computed: {
  },
  methods: {
    ...mapActions('articleStock', ['loadItem']),
    setCurrentRowData (article) {
      this.name = article.name
      this.category_name = article.category_name
      this.purchase_measurement_unit_name = article.purchase_measurement_unit_name
      this.price = article.price
      this.new_price = article.new_price
      if (this.new_price) {
        this.parsePriceInput()
      }
      this.saving = this.saving || false
    },
    handleBlur () {
      if (this.selectedArticle) {
        this.parseAllInputs()
        const saveItem = {
          article: this.selectedArticle.id,
          new_price: this.new_price,
        }
        this.$emit('updateBlur', saveItem)
      }
    },
    async save (custom) {
      // console.log('updejtjtjat')
      if (!this.new_price)
      {
        this.$emit('gotonext')
        return
      }
      if (this.selectedArticle) {
        this.saving = true
        this.parseAllInputs()
        const saveItem = {
          article: this.selectedArticle.id,
          new_price: this.new_price,
        }

        const event = /* this.isNewArticle ? 'save' :  */'update'
        this.$emit(event, saveItem)
        this.editMode = false
        this.saving = false
      }
    },
    parseAllInputs () {
      this.parsePriceInput()
    },
    parsePriceInput () {
      if (!this.new_price) return
      this.new_price = parsePrice(this.new_price, 2)
      // console.log(this.new_price)
    },
    preventLetters ($event) {
      var keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if (keyCode > 64 && keyCode < 91) {
        $event.preventDefault()
      }
    },
    async doClickOutside () {
      if (this.editMode) {
        await this.save()
        this.editMode = false
      }
    },
    startEditMode () {
      if (!this.editMode) {
        this.editMode = true
        this.$nextTick(() => {
          this.$refs.new_price.focus()
        })
      }
    },
    stopEditMOde () {
      if (this.editMode) {
        this.editMode = false
      }
    },
    setStartingArticleFields (article = null) {
      const data = article || this.article
      this.setCurrentRowData(data)
      this.selectedArticle = data
    },
    cancel (event) {
      this.editMode = false
      this.setCurrentRowData(this.article)
    }
  },
  mounted () {
    this.setStartingArticleFields()
  },
  watch: {
    article (val) {
      this.setStartingArticleFields()
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .v-text-field__details {
    display: none !important;
  }

  .problematicArticle {
    background: #be8c8c;
    &:hover {
      background: #be8c8c !important;
    }
  }
</style>
